import React, { Component } from "react"
import { Link } from "gatsby"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import AOS from "aos"
import 'aos/dist/aos.css';
import NewsStrip from "../../components/news-strip";
import mainImg from "../../images/pcv-drivers.jpg";
import driverImg from "../../images/bus-coach-driver-jobs.jpg";
import arrowSvg from "../../images/arrow-circle-right-solid.svg"

class JobsPage extends Component {

  componentDidMount() {
    AOS.init();
    window.addEventListener('load', AOS.refresh);
    // @NOTE: Hack to force AOS to work :(
    window.setTimeout(AOS.refresh, 1000);
  }

  componentDidUpdate() {
    AOS.refresh();
  }

  render() {
    return (
      <Layout>
        <SEO title="PCV Bus and Coach Driver Leeds Jobs" description="PCV Driver? Find your next career at Tetley's Coaches - Leeds' oldest coach operator established 1949." />
        <div className="block-services inner-body-bg">
          <div className="body gutter page-content-parent page-article headblock">
            <h1 className="headblock__heading">PCV Bus &amp; Coach Driver Leeds</h1>
            <p className="headblock__byline">Find a career with Tetley's Coaches</p>
          </div>
          <div className="body gutter page-article page-content-parent">
            <h2 data-aos='fade-left' data-aos-duration="500" style={{ marginBottom: 20 }}>PCV Driver Vacancies – Full Time</h2>
            <div className="page-content">
              <div className="page-content__text" style={{ width: '100%' }}>
                <img src={driverImg} alt="PCV drivers" />

                <p>Tetley’s Motor Services is recruiting Full-Time PCV Drivers to join our established team. This position offers a guaranteed 35-hour week, with plenty of opportunity for overtime across private hire, contract work and major events.</p>
                <h3>What the Role Involves</h3>
                <br></br>
                <ul>
                  <li>Guaranteed <strong>35 hours per week</strong></li>
                  <li>A mix of <strong>private hire, school contracts</strong>, and <strong>event duties</strong></li>
                  <li>Regular <strong>overtime available</strong></li>
                  <li><strong>Smart uniform</strong> provided</li>
                  <li>Driving a <strong>modern, high-spec, well-maintained fleet</strong></li>
                </ul>

                <h3>Pay:</h3>
                <br></br>

                <p>💰 <strong>Monday to Friday:</strong> £14.70 per hour</p>
                <p>💰 <strong>Saturday and Sunday:</strong> £16.25 per hour</p>
                <p>💰 <strong>Rugby events:</strong> +£25/day</p>
                <p>💰 <strong>Football fixtures:</strong> +£50/day</p>
                <p>💰 <strong>Boxing Day & New Year’s Day:</strong> +£75</p>
                <p>💰 <strong>Night-out allowance:</strong> £25 (tax-free)</p>

                <h3>What You Need:</h3>
                <br></br>
                <ul>
                  <li>Full <strong>PCV (Category D) licence</strong></li>
                  <li>Valid <strong>Driver CPC</strong></li>
                  <li>Ability to pass an <strong>enhanced DBS check</strong> (arranged and paid for by the company)</li>
                  <li>A professional attitude and strong customer service skills</li>
                </ul>

                <h3>Benefits:</h3>
                <br></br>
                <p>✔ <strong>SimplyHealth</strong> cashback plan (company funded)</p>
                <p>✔ <strong>Tetley’s Xclusives</strong> retail discounts</p>
                <p>✔ <strong>Discounted rail travel</strong> on FirstGroup services (after 6 months)</p>
                <p>✔ Enhanced holiday pay and <strong>long-service holiday rewards</strong></p>
                <p>✔ Paid medicals</p>
                <p>✔ Company pension scheme</p>
                <p>✔ <strong>Fully funded CPC training</strong></p>

                <div id="jobs-apply" style={{ width: '100%', maxWidth: '100%' }} className="page-content__text">
                  <div className="content-box" style={{ width: '100%', maxWidth: '100%' }}>
                    <h3>Apply now</h3>
                    <p>Please complete our online <a href="https://forms.gle/xbR2G7PPAhZPLe7K8">Application form</a>. Applicants may also email a copy of their CV to <a href="mailto:sales@tetleyscoaches.co.uk">sales@tetleyscoaches.co.uk</a> along with a cover letter.</p>
                    <p>Immediate start available.</p>
                    <a href="https://forms.gle/xbR2G7PPAhZPLe7K8" className='btn btn-grow btn-others btn-small btn-jobs-apply'>
                      <span className='btn-others__text'>Apply</span>
                      <img className='btn-others__icon' src={arrowSvg} alt="" />
                    </a>
                  </div>
                </div>

                <p style={{ margin: 0 }}>
                  <Link to="/applicant-privacy-policy/" className="privacy-notice-link">
                    Applicant privacy notice
                  </Link>
                </p>

              </div>

            </div>
          </div>
        </div>

        <NewsStrip />

      </Layout>
    );
  }
}

export default JobsPage
